const normalizeUrl = (str?: string): string => {
    if (!str) return '';

    if (isSpecialUrl(str)) return str;

    let normalized = removeTrailingSlashBeforeAnchor(str);
    normalized = removeTrailingSlashBeforeQueryString(normalized);
    normalized = removeTrailingSlash(normalized);

    if (isAbsoluteHttpUrl(normalized)) {
        return normalized;
    }

    normalized = ensureLeadingSlash(normalized);

    return normalized;
};

const isSpecialUrl = (str: string): boolean => {
    return (
        isInPageAnchor(str) ||
        isQueryOnlyUrl(str) ||
        isProtocolRelativeUrl(str) ||
        hasNonHttpUrlScheme(str)
    );
};

const isInPageAnchor = (str: string): boolean => {
    return str.startsWith('#');
};

const isQueryOnlyUrl = (str: string): boolean => {
    return str.startsWith('?');
};

const isProtocolRelativeUrl = (str: string): boolean => {
    return str.startsWith('//');
};

const isAbsoluteHttpUrl = (str: string): boolean => {
    return str.startsWith('http://') || str.startsWith('https://');
};

const hasNonHttpUrlScheme = (str: string): boolean => {
    // Matches URLs with non-http schemes (mailto:, tel:, ftp:, data:, etc.)
    // but excludes http: and https:
    const schemePattern = /^[a-z][\da-z+.-]*:/i;
    if (!schemePattern.test(str)) return false;
    return !isAbsoluteHttpUrl(str);
};

const removeTrailingSlashBeforeAnchor = (str: string): string => {
    return str.replace(/\/+#/, '#');
};

const removeTrailingSlashBeforeQueryString = (str: string): string => {
    return str.replace(/\/+\?/, '?');
};

const removeTrailingSlash = (str: string): string => {
    if (str === '/') return str;
    return str.replace(/\/+$/, '');
};

const ensureLeadingSlash = (str: string): string => {
    return str.startsWith('/') ? str : '/' + str;
};

export default normalizeUrl;
